import { render, staticRenderFns } from "./RealEstateModal.vue?vue&type=template&id=684b700e"
import script from "./RealEstateModal.vue?vue&type=script&lang=ts"
export * from "./RealEstateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports